import { Store } from '@/store/store.class'
import { PLANS, Plans, Plan } from '@/api/tripply/models/Plan'
import { Toast } from '@/api/models/Toast'
import { GA } from '@/api/analytics'

interface GlobalState extends Object {
    theme: string;
    lang: string;
    userMenu: boolean;
    myMenu: boolean;
    loading: boolean;
    plans: Plans;
    toasts: Toast[];
    cookieConsent: boolean;
}

let toastDelay = 0

class GlobalStore extends Store<GlobalState> {
  constructor() {
    super({
      name: 'global',
      cached: true,
      state: {
        theme: 'light',
        lang: 'da',
        userMenu: false,
        myMenu: false,
        loading: false,
        plans: PLANS,
        toasts: [],
        cookieConsent: false
      }
    })
  }

  async initialize() {
    // const plans = await plansRef().get()
    // this.mutate(state => state.plans = plans.list as unknown as Plans)
  }

  getPlan(planId: keyof Plans): Plan { return this.state.plans[planId] }

  private SET_THEME(theme: string) {
    this.mutate((state: GlobalState) => {
      state.theme = theme
    })
  }
  toggleUserMenu(value?: boolean) {
    this.mutate(state => state.userMenu = value || !this.state.userMenu)
  }
  toggleMyMenu(value?: boolean) {
    this.mutate(state => state.userMenu = value || !this.state.myMenu)
  }

  changeTheme() {
    const newTheme = this.state.theme == 'dark' ? 'light' : 'dark'
    GA('change_theme', { theme: newTheme })
    this.SET_THEME(newTheme)
  }

  toast(toast: Toast) {
    this.state.toasts.push({ ...toast, key: new Date().getTime() })
    setTimeout(() => {
      this.state.toasts.shift()
      toastDelay -= toast.time || 5000
    }, (toast.time || 5000) + toastDelay)
    toastDelay += toast.time || 5000
  }
  removeToast(index: number) {
    this.mutate(state => state.toasts.splice(index, 1))
  }

  acceptCookies() {
    this.mutate(state => state.cookieConsent = true)
  }
}
export const globalStore = new GlobalStore()